import {
  XRaySection,
  BuildWithMeSection,
  LayerZoomSection,
  AgenticDiffSection,
  TokenTunerSection,
} from '@bq/web-sections';

export function ShowcasePage() {
  return (
    <main data-crd-id="r5.bq-showcase-page" data-crd-layer="r5">
      <XRaySection />
      <BuildWithMeSection />
      <LayerZoomSection />
      <AgenticDiffSection />
      <TokenTunerSection />
    </main>
  );
}
